
export default [
    { path: "*", redirect: { name: "Evaluation" }},
    {
        path: "/resultados",
        name: "evaluationResults",
        component: () =>  import(/* webpackChunkName: "evaluation-results" */ (`@/views/evaluations/evaluation-results.vue`))
    },
    {
        path: "/evaluaciones",
        name: "EvaluationDetail",
        component: () => import(/* webpackChunkName: "evaluation" */ (`@/views/evaluations/evaluation.vue`))
    },
    {
        path: "/evaluacion/:any?",
        name: "Evaluation",
        component: () => import(/* webpackChunkName: "evaluation-init" */ (`@/views/evaluations/evaluation-init.vue`))
    },
    {
        path: "/evaluacion",
        name: "Evaluation",
        component: () => import(/* webpackChunkName: "evaluation-init" */ (`@/views/evaluations/evaluation-init.vue`))
    },
    {
        path: "/disconnect",
        name: "Disconnect",
        component: () => import(/* webpackChunkName: "evaluation-init" */ (`@/views/error/disconnect.vue`))
    },
    {
        path: "/datos-incorrectos",
        name: "DatosIncorrectos",
        component: () => import(/* webpackChunkName: "evaluation-init" */ (`@/views/error/datos-incorrectos.vue`))
    },
    { path: process.env.BASE_URL + "evaluaciones-*", redirect: { name: "ErrorPage" } },
];
